import { ArrowUpRight, Star } from "lucide-react";
import { Reveal } from "./Reveal";

const review = {
  text: "I recently visited a charming cafe nestled near the Anjuna Beach. The cozy ambiance, coupled with a diverse menu, made for a delightful experience. The barista's expertise was evident in the perfectly crafted food — a delectable treat. The attentive staff and warm atmosphere make it a great spot for both a casual coffee date or a peaceful brunch. Highly recommended!",
  author: "Vrushali Chavan",
  meta: "Google Maps review · 2 years ago",
  avatar: "https://lh3.googleusercontent.com/a-/ALV-UjUu7R_m2O_UCBlGaoBBB9pBm7LCc-_71IrjQPQ9TfuB94ykxEz0UQ=w96-h96-p-rp-mo-br100",
  link: "https://goo.gl/maps/n1DSzt2qr9BGMjyd8",
};

export const Review = () => (
  <section className="relative overflow-hidden px-5 py-24 sm:px-8 sm:py-32" data-testid="review-section">
    <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 select-none font-display text-[16rem] italic leading-none text-gold/5" aria-hidden="true">
      &ldquo;
    </div>
    <Reveal className="relative mx-auto flex max-w-3xl flex-col items-center text-center">
      <p className="eyebrow mb-6">04 · From Google Maps</p>
      <div className="mb-8 flex gap-1.5" data-testid="review-stars" aria-label="5 out of 5 stars">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} size={18} className="fill-gold text-gold" />
        ))}
      </div>
      <blockquote className="font-display text-xl italic leading-relaxed text-cream sm:text-2xl" data-testid="review-quote">
        &ldquo;{review.text}&rdquo;
      </blockquote>
      <div className="mt-9 flex items-center gap-4">
        <img
          src={review.avatar}
          alt={review.author}
          loading="lazy"
          className="h-12 w-12 rounded-full border border-gold/40 object-cover"
        />
        <div className="text-left">
          <p className="font-display text-base text-cream" data-testid="review-author">{review.author}</p>
          <p className="font-mono text-[0.6rem] uppercase tracking-[0.22em] text-ash">{review.meta}</p>
        </div>
      </div>
      <a
        href={review.link}
        target="_blank"
        rel="noreferrer"
        data-testid="review-google-link"
        className="group mt-8 flex items-center gap-2 rounded-full border border-cream/20 px-6 py-2.5 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-cream/80 transition-colors duration-300 hover:border-gold hover:text-gold-light"
      >
        Read on Google Maps
        <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>
    </Reveal>
  </section>
);
